//import {Physics, useBox, usePlane} from "@react-three/cannon";
import React, {useRef} from "react";
import * as THREE from "three";
import {Rect, VBounds, Vec2, Vec3} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {LHQInstance} from "../Scene.js";

export const RoomColliders = (props: {lhq: LHQInstance, showBounds: boolean, physics?: /*boolean*/ false})=>{
	const {lhq, showBounds, physics = false} = props;

	const collidersGroupRef = useRef<THREE.Group | null>(null);
	lhq.roomColliders_groupRef = collidersGroupRef;

	const roomBounds = VBounds.FromMinMax(new Vec3(-7.57, -8.81, 0.05), new Vec3(5.96, 7.23, 8.73));
	const min = roomBounds.position;
	const max = roomBounds.position.Plus(roomBounds.size);
	const th = 1;
	//const he = roomBounds.size.z;
	const collidersGroup = <group ref={collidersGroupRef}>
		{/*<BoxCollider_MinMaxByAxis {...{showBounds, physics}} minX={min.x} maxX={max.x} minY={min.y} maxY={max.y} minZ={-th}   maxZ={0}/>
		   <BoxCollider_MinMaxByAxis {...{showBounds, physics}} minX={min.x} maxX={max.x} minY={min.y} maxY={max.y} minZ={max.z} maxZ={max.z + th}/>*/}
		{/* use plane-colliders for floor and ceiling, because a box-collider for the floor fails to catch objects reliably -- and we want the ceiling and floor consistent */}
		{/* z-up: PlaneGeometry faces +z, so the floor (z = min.z) needs no rotation and the ceiling is flipped by PI about x */}
		<PlaneCollider {...{showBounds, physics}} position={roomBounds.Center.NewZ(min.z)} size={roomBounds.size.ToVec2()} rotation={new Vec3(0, 0, 0)}/>
		<PlaneCollider {...{showBounds, physics}} position={roomBounds.Center.NewZ(max.z)} size={roomBounds.size.ToVec2()} rotation={new Vec3(Math.PI, 0, 0)}/>
		<BoxCollider_MinMaxByAxis {...{showBounds, physics}} minX={min.x - th} maxX={min.x}      minY={min.y}      maxY={max.y}      minZ={min.z} maxZ={max.z}/>
		<BoxCollider_MinMaxByAxis {...{showBounds, physics}} minX={min.x}      maxX={max.x}      minY={max.y}      maxY={max.y + th} minZ={min.z} maxZ={max.z}/>
		<BoxCollider_MinMaxByAxis {...{showBounds, physics}} minX={max.x}      maxX={max.x + th} minY={min.y}      maxY={max.y}      minZ={min.z} maxZ={max.z}/>
		<BoxCollider_MinMaxByAxis {...{showBounds, physics}} minX={min.x}      maxX={max.x}      minY={min.y - th} maxY={min.y}      minZ={min.z} maxZ={max.z}/>
	</group>;

	/*if (physics) {
		return <>
			<Physics gravity={[0, -9.81, 0]}>
				{collidersGroup}
				<TestCube/>
			</Physics>
		</>;
	}*/
	return collidersGroup;
};

function PlaneCollider(props: {showBounds: boolean, physics: boolean, position: Vec3, size: Vec2, rotation: Vec3}) {
	const {showBounds, physics, position, size, rotation} = props;

	// Create a plane physics body for the floor
	const [ref] = /*physics
		? usePlane(()=>({
			position: position.To3JPos().toArray(),
			rotation: rotation.To3JRot().toArray() as any,
			type: "Static",
			// Specific material for the floor
			/*material: {
				friction: 0.5,
				restitution: 0.1,
			}*#/
		}))
		:*/ [useRef<THREE.Object3D>(null)];

	return (
		<mesh ref={ref} position={position.To3JPos()} rotation={rotation.To3JRot()} visible={showBounds}>
			<planeGeometry args={[size.x, size.y]} />
			<meshBasicMaterial color="green" opacity={0.5} transparent wireframe />
		</mesh>
	);
}

function BoxCollider_MinMaxByAxis(props: {showBounds: boolean, physics: boolean, minX: number, maxX: number, minY: number, maxY: number, minZ: number, maxZ: number, rotation?: Vec3}) {
	const {showBounds, physics, minX, maxX, minY, maxY, minZ, maxZ, rotation = new Vec3(0, 0, 0)} = props;
	const size = new Vec3(maxX - minX, maxY - minY, maxZ - minZ);
	const center = new Vec3(minX + size.x * 0.5, minY + size.y * 0.5, minZ + size.z * 0.5);
	return <BoxCollider {...{showBounds, physics}} position={center} size={size} rotation={rotation}/>;
}
/*function BoxCollider_MinMax(props: {min: Vec3, max: Vec3, rotation?: Vec3}) {
	const { min, max, rotation = new Vec3(0, 0, 0) } = props;
	const size = max.Minus(min);
	const center = min.Plus(size.Times(0.5));
	return <BoxCollider position={center} size={size} rotation={rotation}/>;
}*/
function BoxCollider(props: {showBounds: boolean, physics: boolean, position: Vec3, rotation?: Vec3, size: Vec3}) {
	const {showBounds, physics, position, rotation = new Vec3(0, 0, 0), size} = props;

	// Create a box physics body
	const [ref] = /*physics
		? useBox(()=>({
			position: position.To3JPos().toArray(),
			rotation: rotation.To3JRot().toArray() as any,
			args: size.To3JPos().toArray(), // width, height, depth
			type: "Static"
		}))
		:*/ [useRef<THREE.Object3D>(null)];

	return (
		<mesh ref={ref} position={position.To3JPos()} rotation={rotation.To3JRot()} visible={showBounds}>
			<boxGeometry args={size.To3JPos().toArray()}/>
			<meshBasicMaterial wireframe color="red" opacity={0.5} transparent
				// we need to make this double-sided for some reason, otherwise the raycast (in ImageFrame.tsx) only hits against the "far side" of the box!
				// (there's probably a better way to do this, but this works for now)
				side={THREE.DoubleSide}
			/>
		</mesh>
	);
}

// just a test cube to see if the physics works
/*function TestCube() {
	const [ref] = useBox(()=>({
		mass: 1, // Add mass for gravity to affect it
		position: [0, 5, 0],
		args: [1, 1, 1],
		type: "Dynamic"
	}));

	return (
		<mesh ref={ref}> {/*position={[0, 5, 0]}>*#/}
			<boxGeometry args={[1, 1, 1]}/>
			<meshStandardMaterial color="blue"/>
		</mesh>
	);
}*/